import Immutable from 'immutable';

const initialState = Immutable.fromJS({
  index: {
    records: {},
  },
});

/* Index of tours */
function indexLoadingStarted(state, _payload) {
  state.setIn(['index', 'loading'], true);
  state.setIn(['index', 'completed'], false);
  state.setIn(['index', 'failed'], false);
  state.setIn(['index', 'errors'], {});
  return state;
}

function indexLoadingCompleted(state, payload) {
  const recordsById = payload.reduce((memo, tour) => {
    memo[tour.id.toString()] = tour;
    return memo;
  }, {});
  state.setIn(['index', 'records'], Immutable.fromJS(recordsById));
  state.setIn(['index', 'completed'], true);
  state.setIn(['index', 'failed'], false);
  state.setIn(['index', 'errors'], {});
  stopIndexLoading(state);
  return state;
}

function indexLoadingCached(state, _payload) {
  return stopIndexLoading(state);
}

function indexLoadingFailed(state, payload) {
  state.setIn(['index', 'completed'], false);
  state.setIn(['index', 'failed'], true);
  state.setIn(['index', 'errors'], payload.errors);
  stopIndexLoading(state);
  return state;
}

function stopIndexLoading(state) {
  state.setIn(['index', 'loading'], false);
  return state;
}

/* Individual records */
function tourLoadingStarted(state, payload) {
  state.setIn(['records', payload.id.toString(), 'loading'], true);
  state.setIn(['records', payload.id.toString(), 'completed'], false);
  state.setIn(['records', payload.id.toString(), 'failed'], false);
  state.setIn(['records', payload.id.toString(), 'errors'], {});
  return state;
}

function tourLoadingCompleted(state, payload) {
  state.setIn(
    ['records', payload.id.toString(), 'record'],
    Immutable.fromJS(payload)
  );
  state.setIn(['records', payload.id.toString(), 'completed'], true);
  state.setIn(['records', payload.id.toString(), 'failed'], false);
  state.setIn(['records', payload.id.toString(), 'errors'], {});
  state.setIn(['records', payload.id.toString(), 'loading'], false);
  return state;
}

function tourLoadingCached(state, payload) {
  state.setIn(['records', payload.id.toString(), 'loading'], false);
  return state;
}

function tourLoadingFailed(state, payload) {
  state.setIn(['records', payload.id.toString(), 'completed'], false);
  state.setIn(['records', payload.id.toString(), 'failed'], true);
  state.setIn(['records', payload.id.toString(), 'errors'], payload.errors);
  state.setIn(['records', payload.id.toString(), 'loading'], false);
  return state;
}

/* Availability */
function loadAvailabilityDatesStarted(state, _payload) {
  state.setIn(['availabilityDates', 'loading'], true);
  state.setIn(['availabilityDates', 'completed'], false);
  state.setIn(['availabilityDates', 'failed'], false);
  return state;
}

function loadAvailabilityDatesCompleted(state, payload) {
  state.setIn(['availabilityDates', 'loading'], false);
  state.setIn(['availabilityDates', 'completed'], true);
  state.setIn(
    ['availabilityDates', 'records'],
    Immutable.fromJS(payload.dates)
  );
  state.setIn(['availabilityDates', 'slots'], Immutable.fromJS(payload.slots));
  state.setIn(
    ['availabilityDates', 'slot_ids'],
    Immutable.fromJS(payload.availability_slot_ids || {})
  );
  state.setIn(
    ['availabilityDates', 'addons_records'],
    Immutable.fromJS(payload.addon_availability)
  );
  state.setIn(['availabilityDates', 'failed'], false);
  return state;
}

function loadAvailabilityDatesFailed(state, _payload) {
  state.setIn(['availabilityDates', 'loading'], false);
  state.setIn(['availabilityDates', 'completed'], false);
  state.setIn(['availabilityDates', 'failed'], true);
  return state;
}

function loadAvailabilityDatesCached(state, _payload) {
  state.setIn(['availabilityDates', 'loading'], false);
  state.setIn(['availabilityDates', 'completed'], true);
  state.setIn(['availabilityDates', 'failed'], false);
  return state;
}

export default function reducer(state = initialState, { type, payload }) {
  return state.withMutations((state) =>
    (
      ({
        TOUR_INDEX: indexLoadingStarted,
        TOUR_INDEX_COMPLETED: indexLoadingCompleted,
        TOUR_INDEX_CACHED: indexLoadingCached,
        TOUR_INDEX_FAILED: indexLoadingFailed,
        TOUR_LOAD: tourLoadingStarted,
        TOUR_LOAD_COMPLETED: tourLoadingCompleted,
        TOUR_LOAD_CACHED: tourLoadingCached,
        TOUR_LOAD_FAILED: tourLoadingFailed,
        TOUR_AVAILABILITY_DATES_LOAD: loadAvailabilityDatesStarted,
        TOUR_AVAILABILITY_DATES_LOAD_COMPLETED: loadAvailabilityDatesCompleted,
        TOUR_AVAILABILITY_DATES_LOAD_CACHED: loadAvailabilityDatesCached,
        TOUR_AVAILABILITY_DATES_LOAD_FAILED: loadAvailabilityDatesFailed,
      })[type] || (() => state)
    )(state, payload)
  );
}
